// =============================================================================
// StatsView.ts — Placar da CPI (segure TAB): skills com nível + inimigos
// cassados por skill, por jogador. Cada arma mostra a receita de evolução
// (#98); arma suprema ganha o selo SUPREMA no lugar do nível.
// =============================================================================
import { MAX_WEAPON_LEVEL, WEAPON_TABLE } from '../../../shared/weapons';
import { UPGRADE_TABLE } from '../../../shared/upgrades';
import type { GameStartPlayer, Snapshot } from '../../../shared/protocol';
import { abilityIcon, killsIcon, pingIcon } from './pixelIcons';
import { $, $in, charImg, type Overlay } from './dom';

// Verde até 80ms, amarelo até 160ms, vermelho acima (padrão de placar de jogo)
function pingColor(ms: number): string {
  return ms <= 80 ? '#2ecc71' : ms <= 160 ? '#f7d117' : '#d42a2a';
}

export class StatsView implements Overlay {
  // Raiz única do overlay: todos os ids desta view moram dentro do #stats-overlay
  readonly root: HTMLElement = $('stats-overlay');
  private readonly q = $in(this.root);

  show(snap: Snapshot | null, playersInfo: Map<string, GameStartPlayer>, youId: string | null, ping = 0): void {
    if (!snap) return;
    const pingEl = this.q('stats-ping');
    pingEl.innerHTML = `${pingIcon(13)} ${ping > 0 ? `${ping}ms` : '--'}`;
    pingEl.style.color = ping > 0 ? pingColor(ping) : '#888';

    const box = this.q('stats-players');
    box.innerHTML = '';
    for (const p of snap.players) {
      const info = playersInfo.get(p.id);
      const card = document.createElement('div');
      card.className = 'stats-player' + (p.id === youId ? ' me' : '');
      const weapons = p.wp.map(([wid, lvl, wk]) => {
        const w = WEAPON_TABLE[wid];
        // Receita de evolução (#98) embaixo do nome; suprema troca o nível pelo selo
        const evo = w?.evolution;
        const receita = w?.evolved
          ? ''
          : evo
            ? `<small class="sw-recipe">nv ${MAX_WEAPON_LEVEL} + ${UPGRADE_TABLE[evo.passive]?.nome ?? evo.passive} → ${WEAPON_TABLE[evo.into]?.nome ?? evo.into}</small>`
            : '';
        return `
          <div class="stats-weapon">
            <span class="sw-icon">${abilityIcon('weapon', wid, 16)}</span>
            <span class="sw-nome">${w?.nome ?? wid}${receita}</span>
            <span class="sw-lvl${w?.evolved ? ' supreme' : ''}">${w?.evolved ? 'SUPREMA' : `nv ${lvl}`}</span>
            <span class="sw-kills">${killsIcon(11)} ${wk}</span>
          </div>`;
      }).join('');
      card.innerHTML = `
        <div class="stats-player-head">
          ${charImg(info?.charId ?? 'lula', 30, false, info?.skinId)}
          <b>${info?.name ?? '?'}${p.id === youId ? ' (você)' : ''}</b>
          <span class="stats-total">${killsIcon(12)} ${p.k} cassados</span>
        </div>
        <div class="stats-weapons">${weapons}</div>`;
      box.appendChild(card);
    }
    this.root.style.display = '';
  }

  hide(): void {
    this.root.style.display = 'none';
  }

  visible(): boolean {
    return this.root.style.display !== 'none';
  }
}
